<template>
  <div>
    <SupportAdmin v-if="isRoot || isCompanyRootManager" />
    <SupportUser v-else />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SupportUser from "./SupportUser.vue";
import SupportAdmin from "./SupportAdmin.vue";

export default {
  name: "SupportHub",
  components: {
    SupportUser,
    SupportAdmin,
  },
  computed: {
    ...mapGetters(["profile"]),
    isRoot() {
      return this.profile && this.profile.role === "root";
    },
    isCompanyRootManager() {
      return (
        this.profile &&
        this.profile.role === "company-root" &&
        Array.isArray(this.profile.managedCompanies) &&
        this.profile.managedCompanies.length > 0
      );
    },
  },
};
</script>
